/**
 * Product Variant Pills Manager - Moon Moon Agency
 * Coche le radio caché (data-variant-input) associé à une pill cliquée
 * (option Fermeté...), même mécanique que data-variant-photo-radio dans
 * mm-product-variant-photo-grid.js : le 'change' bubbling jusqu'au
 * <variant-selector> déclenche la mise à jour du variant.
 */

const ProductVariantPillsManager = {
	config: {
		selectors: {
			trigger: '[data-variant-pill-radio]',
		},
	},

	init() {
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest(this.config.selectors.trigger);
			if (!trigger) return;
			this.select(trigger);
		});
	},

	select(trigger) {
		const radio = document.getElementById(trigger.dataset.variantPillRadio);
		if (!radio || radio.checked) return;

		radio.checked = true;
		radio.dispatchEvent(new Event('change', { bubbles: true }));

		trigger.closest('.mm-product-variant-pills-grid')
			.querySelectorAll(this.config.selectors.trigger)
			.forEach((option) => {
				const isSelected = option === trigger;
				option.classList.toggle('is-active', isSelected);
				option.setAttribute('aria-pressed', String(isSelected));
			});
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => ProductVariantPillsManager.init());
} else {
	ProductVariantPillsManager.init();
}
